<template>
  <div class="relative inline-flex">
    <button
      ref="trigger"
      class="flex h-8 w-8 items-center justify-center rounded-full text-gray-400 hover:text-gray-500"
      :class="{ 'bg-gray-200 text-gray-500': dropdownOpen }"
      aria-haspopup="true"
      @click.stop="toggleDropdownOpen"
      :aria-expanded="dropdownOpen"
    >
      <!-- <span class="sr-only">Menu</span>
      <n-icon size="20">
        <EllipsisHorizontal />
      </n-icon> -->
      <span>{{ getCurrentLocale }}</span>
    </button>
    <div
      v-if="dropdownOpen"
      class="min-w-16 absolute top-full z-10 mt-1 origin-top-right overflow-hidden rounded bg-white p-1.5 shadow-lg"
      :class="align === 'right' ? 'right-0' : 'left-0'"
    >
      <ul ref="dropdown" @focusin="dropdownOpen = true" @focusout="dropdownOpen = false">
        <li v-for="item in getLocales" :key="item.id">
          <a
            href="#"
            class="flex items-center rounded px-1.5 py-1 text-sm font-medium text-gray-600 transition duration-200 ease-in-out hover:bg-gray-100 hover:text-gray-800"
            @click="setCurrentLocale(item.name)"
          >
            <span>{{ item.name }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, onMounted, onUnmounted, defineComponent, computed, watch } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { NIcon } from "naive-ui";
import { EllipsisHorizontal } from "@vicons/ionicons5";

export default defineComponent({
  components: {
    // NIcon,
    // EllipsisHorizontal,
  },
  name: "DropdownEditMenu",
  props: ["align"],
  setup() {
    const store = useStore();
    const { locale } = useI18n({ useScope: "global" });

    const dropdownOpen = ref(false);
    const trigger = ref();
    const dropdown = ref();

    const toggleDropdownOpen = () => {
      dropdownOpen.value = !dropdownOpen.value;
    };

    // close on click outside
    const clickHandler = ({ target }: { target: any }) => {
      if (!dropdownOpen.value || dropdown.value.contains(target) || trigger.value.contains(target))
        return;
      dropdownOpen.value = false;
    };

    // close if the esc key is pressed
    const keyHandler = ({ keyCode }: { keyCode: number }) => {
      if (!dropdownOpen.value || keyCode !== 27) return;
      dropdownOpen.value = false;
    };

    const getLocales = computed(() => store.getters["locales/GET_LOCALES"]);
    const getCurrentLocale = computed(() => store.getters["locales/GET_CURRENT_LOCALE"]);
    const setCurrentLocale = (option: string) => {
      store.commit("locales/SET_CURRENT_LOCALE", option);
      dropdownOpen.value = false;
      locale.value = option;
    };

    onMounted(() => {
      document.addEventListener("click", clickHandler);
      document.addEventListener("keydown", keyHandler);
    });

    onUnmounted(() => {
      document.removeEventListener("click", clickHandler);
      document.removeEventListener("keydown", keyHandler);
    });

    return {
      dropdownOpen,
      toggleDropdownOpen,
      trigger,
      dropdown,
      getLocales,
      getCurrentLocale,
      setCurrentLocale,
    };
  },
});
</script>
